import { createFileRoute } from '@tanstack/react-router';
import FormsFixtureDisabled from '@/components/forms/dev/FormsFixtureDisabled';
import FormsFixtureHost from '@/components/forms/dev/FormsFixtureHost';

const FORMS_DEV_BASE_PATH = '/dev/Forms';

function FormsDevRoute(): React.JSX.Element {
  if (import.meta.env.VITE_FORMS_FIXTURE_ENABLED !== 'true') {
    return <FormsFixtureDisabled />;
  }

  return <FormsFixtureHost basePath={FORMS_DEV_BASE_PATH} />;
}

export const Route = createFileRoute('/dev/Forms')({
  component: FormsDevRoute,
});
